import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

@connect(state => ({
  notification: state.notification.get('data'),
}))

class Notification extends Component {
  static propTypes = {
    notification: PropTypes.object,
  }

  static defaultProps = {
    notification: null,
  }

  render() {
    const { message, type } = this.props.notification
    if (!message) return null

    return (
      <div className='row'>
        <div className={ `alert ${ type } fade-out-long` }>
          {message}
        </div>
      </div>
    )
  }
}

export default Notification



// WEBPACK FOOTER //
// ./src/components/Notification/index.jsx